import React, { Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import { ThemeProvider } from './contexts/ThemeContext';
import { TestConfigProvider } from './contexts/TestConfigContext';
import Layout from './components/Layout/Layout';
import NotFound from './pages/NotFound';
import { APP_ROUTES } from './config/routes';

const LoadingFallback = () => (
  <Box display="flex" justifyContent="center" alignItems="center" minHeight={400}>
    <CircularProgress size={40} />
  </Box>
);

function App() {
  return (
    <Router>
      <ThemeProvider>
        <Layout>
          <Suspense fallback={<LoadingFallback />}>
            <Routes>
              {APP_ROUTES.map(({ path, component: Page, withTestConfig }) => (
                <Route
                  key={path}
                  path={path}
                  element={
                    withTestConfig ? (
                      <TestConfigProvider>
                        <Page />
                      </TestConfigProvider>
                    ) : (
                      <Page />
                    )
                  }
                />
              ))}
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Suspense>
        </Layout>
      </ThemeProvider>
    </Router>
  );
}

export default App;
